<div class="ShippingMainContent">

    <div class="HalfContentTitle">
        {{'TrackShipment' | translate}}
    </div>

    <div class="ShippingCompanySelectContainer">
        <div class="ShippingCompany" *ngFor="let s of this.ShippingCompanies;let i = index;" (click)="SelectShippingCompany(s);" [ngClass]="{'SelectedShippingCompany': s.IsSelected == true}">
            <div class="ShippingCompanyIcon">
                <i class="material-icons" *ngIf="s.IsSelected == true;" style="color: #0082e6;">radio_button_on</i>
                <i class="material-icons" *ngIf="s.IsSelected == false;">radio_button_off</i>
            </div>
            <div class="ShippingCompanyImage">
                <img [src]="this.parent.BackendServiceUrl + s.ImagePath">
            </div>
        </div>
    </div>

    <div class="HalfContent" style="width: 65%;">
        <div class="B2BBodyTopSearchContainer">
            <p class="B2BBodyTopSearchContainerTitle">{{'EnterTrackingNumber' | translate}}</p>
            <div class="CentralSearchContainer">
              <mat-spinner *ngIf="loadingShipment" class="loadingProductsSpinner" [diameter]="25"></mat-spinner>
              <input type="text" class="CentralSearch" [(ngModel)]="this.SearchTerm" matInput (ngModelChange)="this.searchTermUpdate.next($event)" (click)="InitializeSearch();">
              <i class="material-icons" *ngIf="!(this.SearchTerm?.length > 0) && !loadingShipment;">search</i>
              <i class="material-icons" style="color:red;" *ngIf="this.SearchTerm?.length > 0 && !loadingShipment;" (click)="this.SearchTerm = '';">close</i>
            
              <div class="CentralSearchResultsContainer" *ngIf="Trackings?.length > 0;">
                <div *ngFor="let tracking of this.Trackings;" class="CentralSearchResult" (click)="SelectTracking(tracking);">
                  <div class="SearchResultImage">
                    <img [src]="this.parent.BackendServiceUrl + tracking.ShippingCompany.ImagePath">
                  </div>
                  <div class="SearchResultText">
                    <p class="DottedRow">{{'TrackingNumber' | translate}}: {{tracking.TrackingLabel}}</p>
                    <p class="DottedRow" *ngIf="tracking.ShippingDirection.ID == -1;">{{'Sender'| translate}}: {{tracking.Sender.ContactCompany}}</p>
                    <p class="DottedRow" *ngIf="tracking.ShippingDirection.ID == 1;">{{'Receiver'| translate}}: {{tracking.Receiver.ContactCompany}}</p>
                    <p class="DottedRow" *ngIf="tracking.ShippingServiceType?.ID != null;">{{tracking.ShippingServiceType?.Name}}</p>
                    <p class="DottedRow">{{'Total' | translate}}: {{tracking.TotalWeight}}{{tracking.WeightType?.Name}}</p>
                  </div>
                  <div class="SearchResultInfo">
                    <p class="DottedRow">({{tracking.ShippingDirection.Name}})</p>
                    <p class="DottedRow" *ngFor="let Box of tracking.Boxes;let i = index;">{{'Box' | translate}} {{i+1}}: ({{Box?.Weight}}{{tracking.WeightType?.Name}}) {{Box?.Length}} x {{Box?.Width}} x {{Box?.Height}} cm</p>
                </div>
                </div>
              </div>
            </div>
            <button (click)="TrackShippingLabel();" mat-raised-button color="primary" class="CheckShipmentButton">
                <i class="material-icons">near_me</i>
                <span>{{'Check' | translate}}</span>
            </button>
        </div>

        <div class="TrackHistoryContainer" *ngIf="TrackEvents?.length > 0 && !loadingShipment">
            <p class="TrackHistoryContainerTitle">
                {{'TrackingEvents' | translate}}
                <button mat-raised-button color="primary" class="PrintButton" (click)="CopyLabel();">
                    <span>{{'Copy' | translate}}</span>
                    <i class="material-icons">content_copy</i>
                </button>

                <button mat-raised-button color="primary" class="PrintButton" (click)="PrintShippingLabel(this.SearchTerm);">
                    <span>{{'PrintDocument' | translate}}</span>
                    <i class="material-icons">local_print_shop</i>
                </button>

                <button mat-raised-button class="PrintButton" *ngIf="CurrentTracking.AccountingDocumentID?.length > 0;" (click)="this.parent.GoToDocumentPage(CurrentTracking.AccountingDocumentID, CurrentTracking.ShippingDirection?.ID, CurrentTracking.CompanyID);">
                    <span>{{CurrentTracking.AccountingNumberDisplayValue}}</span>
                    <i class="material-icons">linear_scale</i>
                </button>
            </p>
            <p class="TrackHistoryContainerTitleP" *ngIf="CurrentTracking?.ShippingCompany?.length > 0;">{{'ShippingCompany' | translate}}: {{CurrentTracking.ShippingCompany.Name}}</p>
            <p class="TrackHistoryContainerTitleP" *ngIf="CurrentTracking?.Box?.TrackingLabel?.length > 0;">{{'TrackingNumber' | translate}}: {{CurrentTracking.Box.TrackingLabel}}</p>
            <p class="TrackHistoryContainerTitleP" *ngIf="CurrentTracking?.ShippingResponsability?.Name?.length > 0;">{{'ShippingResponsability' | translate}}: {{CurrentTracking.ShippingResponsability.Name}}</p>
            <p class="TrackHistoryContainerTitleP" *ngIf="CurrentTracking?.ShippingServiceType?.Name?.length > 0;">{{'ShippingServiceType' | translate}}: {{CurrentTracking.ShippingServiceType.Name}}</p>
            <p class="TrackHistoryContainerTitleP" *ngIf="CurrentTracking?.Partner?.Name?.length > 0;">{{'Partner' | translate}}: {{CurrentTracking.Partner.Name}}</p>
            <p class="TrackHistoryContainerTitleP">{{'Dimentions' | translate}}:</p>
            <p class="TrackHistoryContainerTitleP">
                <span *ngFor="let box of this.CurrentTracking.Boxes;let i = index;">
                   {{i + 1}}: ({{box?.Weight}}{{CurrentTracking.WeightType?.Name}}) {{box?.Length}}X{{box?.Width}}X{{box?.Height}} CM
                </span>
            </p>
        </div>
        <div class="TrackHistoryContainer" *ngIf="TrackEvents?.length > 0 &&  !loadingShipment;">
            <div *ngFor="let e of this.TrackEvents; let i=index;" class="TrackEventContainer" [ngClass]="{ 'different-day': e.FirstEventOfTheDay}">
                <div class="TrackEventContainerTime">
                    <span>{{e.DateTimeUI}}</span>
                </div>
                <div class="TrackEventContainerArrow">
                    <div class="TrackEventContainerArrowBody"></div>
                    <i *ngIf="e.Status.ID != 14;" class="material-icons">radio_button_checked</i>
                    <i *ngIf="e.Status.ID == 14;" class="material-icons" style="color: #32aa3a;">check_circle</i>
                </div>
                <div class="TrackEventContainerContent">
                    <span>{{e.Event}}</span>
                    <span *ngIf="e.Status.ID == 14;" class="DeliveredStatus">{{e.Status.Name}}</span>
                    <span *ngIf="e.Status.ID != 14;" class="TranzitStatus">{{e.Status.Name}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="HalfContent" style="width: 35%;">
    </div>
</div>